import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'
import Typography from '@mui/material/Typography'
import { node, func, bool, string, object } from 'prop-types'
import { t } from '@lingui/core/macro'

export const CvsDrawer = ({
  onClose = () => {},
  visible = false,
  children,
  title = '',
  containerStyles = {},
  onDone = null,
}) => {
  return (
    <Drawer
      anchor="right"
      open={Boolean(visible)}
      onClose={onClose}
      ModalProps={{ 'data-test-cmp-id': 'drawer-modal' }}
      SlideProps={{ 'data-test-cmp-id': 'drawer-slide' }}
    >
      <div style={{ width: 400, ...containerStyles }}>
        <AppBar position="relative" style={{ padding: 24 }}>
          <Typography variant="h6" style={{ color: 'white' }}>
            {title}
          </Typography>
        </AppBar>
        {children}
        {onDone && (
          <Button variant="outlined" color="secondary" fullWidth onClick={onDone}>
            {t`Done`}
          </Button>
        )}
      </div>
    </Drawer>
  )
}

CvsDrawer.propTypes = {
  onClose: func,
  visible: bool,
  children: node.isRequired,
  title: string,
  containerStyles: object,
  onDone: func,
}
